/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./basic-form.vue?vue&type=template&id=d54c64c0&scoped=true&"
import script from "./basic-form.vue?vue&type=script&lang=ts&"
export * from "./basic-form.vue?vue&type=script&lang=ts&"
import style0 from "./basic-form.vue?vue&type=style&index=0&id=d54c64c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54c64c0",
  null
  
)

export default component.exports